module.exports = "<div class=\"page\">\n\t<h1>Oops!</h1>\n\t<h2>We couldn't find the page you ask for.</h2>\n\n\t<p *ngIf=\"user.logged_in\">Go back to <a routerLink=\"/dashboard\">Dashboard</a></p>\n\t<p *ngIf=\"!user.logged_in\">Go back to <a routerLink=\"/\">Home page</a></p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/not-found/not-found.component.html
// module id = ../../../../../src/app/not-found/not-found.component.html
// module chunks = main